import React from 'react';
import ErrorPage from './error';
import { Errors } from './types';
interface Props {
  statusCode: Errors;
}
export default function ErrorContent({
  statusCode
}: Props) {
  return <div className='container relative mx-auto flex min-h-[calc(100dvh-134px)] items-center lg:w-[344px]' data-sentry-component="ErrorContent" data-sentry-source-file="error-content.tsx">
            <ErrorPage errorCode={statusCode} data-sentry-element="ErrorPage" data-sentry-source-file="error-content.tsx" />
        </div>;
}